import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeOpenPrice: (value: Nullable<number>) => void;
}

export const OpenPrice: React.FC<IProps> = React.memo(({ changeOpenPrice }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterOpenPricePercent') }], [t]);

	return (
		<FormInput
			testId="OpenPrice"
			type="number"
			min={0}
			precision={2}
			name="openPrice"
			label="openPricePercentLabel"
			onChangeNumber={changeOpenPrice}
			validationRules={validationRules}
		/>
	);
});
